export default __webpack_public_path__ + "static/media/pe2_3.7a446cf6.jpg";